export default "__VITE_ASSET__DyOzcLV8__"